function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery } from "@apollo/client";
import { Field, Form as FormikForm, Formik, FieldArray } from "formik";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import { FiToggleRight, FiToggleLeft } from "react-icons/fi";
import { HiOutlineDotsVertical } from "react-icons/hi";
import * as Yup from "yup";
import { FilterContext, UserContext } from "../index";
import "./RiskRuleSetting.css";
import { LIST_RISK_DETECTOR_RULE_QUERY, RULE_ORGANISATION_USER_DETAILS_QUERY, ADD_RISK_DETECTOR_RULE_MUTATION, DELETE_RISK_DETECTOR_RULE_MUTATION, CHANGE_STATUS_RISK_DETECTOR_RULE_MUTATION, EDIT_RISK_DETECTOR_RULE_MUTATION } from "./query";
import Select from "react-select";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import { PlanUpgradeMessage } from "./../WorkLoadAnalysisReport/WorkLoadAnalysisReport";
var RiskSchema = Yup.object().shape({
  ruleName: Yup.string().trim().max(60, "*Required only 60 characters").required("Required")
  // ruleType: Yup.string().required("Required"),
  // ruleTime: Yup.string().required("Required"),
  // ruleDays: Yup.string().required("Required"),
});
var RiskRuleSetting = function RiskRuleSetting(props) {
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    organisationSettings = _React$useContext.organisationSettings,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var loadPage = role === "Admin" || role === null;
  var Redirect = props.redirect;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    riskModal = _useState2[0],
    setRiskModal = _useState2[1];
  var handleClose = function handleClose() {
    return setRiskModal(null);
  };
  var handleShow = function handleShow(data) {
    setRiskModal(data);
  };
  if (organisationBilling.planName == "free") {
    return /*#__PURE__*/React.createElement(PlanUpgradeMessage, {
      displayName: user.displayName,
      history: props === null || props === void 0 ? void 0 : props.history
    });
  }
  var _useQuery = useQuery(LIST_RISK_DETECTOR_RULE_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !loadPage
    }),
    listRiskDetectorRule = _useQuery.data,
    listRiskError = _useQuery.error,
    listRiskLoading = _useQuery.loading;
  var _useQuery2 = useQuery(RULE_ORGANISATION_USER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId
      }
    }),
    ruleUserData = _useQuery2.data,
    ruleUserError = _useQuery2.error,
    ruleUserLoading = _useQuery2.loading;
  var _useMutation = useMutation(DELETE_RISK_DETECTOR_RULE_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    deleteRiskDetectorRule = _useMutation2[0],
    deleting = _useMutation2[1].loading;
  var _useMutation3 = useMutation(CHANGE_STATUS_RISK_DETECTOR_RULE_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    changeStatusRiskDetectorRule = _useMutation4[0],
    statusChanging = _useMutation4[1].loading;
  var _onDelete = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ruleId) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return deleteRiskDetectorRule({
              variables: {
                organisationId: organisationId,
                ruleId: ruleId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LIST_RISK_DETECTOR_RULE_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 2:
            response = _context.sent;
            if (!(!response || !response.data || response.data.deleteRiskDetectorRule === null)) {
              _context.next = 7;
              break;
            }
            throw new Error("error");
          case 7:
            toast.success("Rule deleted successfully!");
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [riskModal, organisationId]);
  var _onStatusChange = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ruleId, status) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return changeStatusRiskDetectorRule({
              variables: {
                ruleId: ruleId,
                status: status
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LIST_RISK_DETECTOR_RULE_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 2:
            response = _context2.sent;
            if (!(!response || !response.data || response.data.changeStatusRiskDetectorRule === null)) {
              _context2.next = 7;
              break;
            }
            throw new Error("error");
          case 7:
            toast.success("Rule status modified!");
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  if (!loadPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  if (listRiskLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (listRiskError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  //console.log("listRiskDetectorRuleData", listRiskDetectorRule?.listRiskDetectorRule);

  var listRiskDetectorRuleData = listRiskDetectorRule === null || listRiskDetectorRule === void 0 ? void 0 : listRiskDetectorRule.listRiskDetectorRule;
  if (!listRiskDetectorRuleData) {
    return null;
  }

  //const { riskDetectorRuleBytype } = listRiskDetectorRuleData;
  var isMobileView = window.innerWidth < 768;
  return /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-setting-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-setting-root-rule-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "font-weight-bold",
    onClick: function onClick() {
      return handleShow({});
    }
  }, "Create Risk Triggers")), /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-setting-root-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-setting-root-card-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-setting-root-card-content"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-primary text-capitalize"
  }, "Risk Triggers"), listRiskDetectorRuleData.length ? /*#__PURE__*/React.createElement(React.Fragment, null, isMobileView ? /*#__PURE__*/React.createElement(MobileViewTable, {
    listRiskDetectorRuleData: listRiskDetectorRuleData,
    onDelete: _onDelete,
    onStatusChange: _onStatusChange,
    handleShow: handleShow,
    statusChanging: statusChanging
  }) : /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "risk-rule-setting-root-card-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "risk-rule-setting-root-card-table-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Title"), /*#__PURE__*/React.createElement("th", null, "Rule condition"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", {
    className: "risk-rule-setting-card-table-body"
  }, listRiskDetectorRuleData.map(function (rule) {
    var ruleId = rule.ruleId,
      ruleName = rule.ruleName,
      ruleDays = rule.ruleDays,
      createdAt = rule.createdAt,
      status = rule.status,
      organisationId = rule.organisationId,
      rules = rule.rules,
      excludeUser = rule.excludeUser;
    var ruleDayTitle = ruleDays > 1 ? "days" : "day";
    var modifyStatus = status === "active" ? "inactive" : "active";
    return /*#__PURE__*/React.createElement("tr", {
      key: "rule",
      className: "risk-rule-setting-card-table-data-details"
    }, /*#__PURE__*/React.createElement("td", {
      className: "risk-rule-setting-card-table-data-details-report-name"
    }, ruleName), /*#__PURE__*/React.createElement("td", {
      className: "risk-rule-setting-card-table-data-details-report-type"
    }, "Avg", " ", rules.map(function (data, index) {
      var ruleTimeTitle = Number(data.ruleTimeSec) / 60 / 60 > 1 ? "hours" : "hour";
      return /*#__PURE__*/React.createElement("span", {
        className: "risk-setting-rule-type-color"
      }, data.ruleType == "Unproductive hours" ? "Unproductive Apps Time" : data.ruleType, " ", "is ", data.ruleTimeCondition, " ", Number(data.ruleTimeSec) / 60 / 60, " ", ruleTimeTitle, " ", rules.length === index + 1 ? "" : "&& ");
    }), "in last", " ", /*#__PURE__*/React.createElement("span", {
      className: "risk-setting-rule-type-color"
    }, ruleDays, " ", ruleDayTitle)), /*#__PURE__*/React.createElement("td", {
      className: "risk-rule-setting-card-table-data-icon"
    }, /*#__PURE__*/React.createElement(ActionMenuWithButtons, {
      onDelete: function onDelete() {
        return _onDelete(ruleId);
      },
      onStatusChange: function onStatusChange() {
        return _onStatusChange(ruleId, modifyStatus);
      },
      onEdit: function onEdit() {
        return handleShow({
          ruleId: ruleId,
          ruleName: ruleName,
          ruleDays: ruleDays,
          organisationId: organisationId,
          rules: rules,
          excludeUser: excludeUser
        });
      },
      deleteProps: {
        title: "Delete rule",
        buttonText: "Delete",
        message: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
          className: "font-weight-bold mb-2"
        }, "Are you sure to delete this rule?"), /*#__PURE__*/React.createElement("p", {
          className: "text-secondary"
        }, "However you will be able to create a new rule like this again anytime."))
      },
      status: status,
      statusChanging: statusChanging
    })));
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "no-data-risk-setting"
  }, "yet to create new rule")))), /*#__PURE__*/React.createElement(RiskRuleModal, {
    riskModal: riskModal,
    handleClose: handleClose,
    organisationId: organisationId,
    ruleUserData: ruleUserData,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }));
};
var MobileViewTable = function MobileViewTable(props) {
  var listRiskDetectorRuleData = props.listRiskDetectorRuleData,
    _onDelete2 = props.onDelete,
    _onStatusChange2 = props.onStatusChange,
    statusChanging = props.statusChanging,
    handleShow = props.handleShow;
  return /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "risk-rule-setting-root-card-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "risk-rule-setting-root-card-table-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Title"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", {
    className: "risk-rule-setting-card-table-body"
  }, listRiskDetectorRuleData.map(function (rule) {
    var ruleId = rule.ruleId,
      ruleName = rule.ruleName,
      ruleDays = rule.ruleDays,
      createdAt = rule.createdAt,
      status = rule.status,
      organisationId = rule.organisationId,
      rules = rule.rules,
      excludeUser = rule.excludeUser;
    var ruleDayTitle = ruleDays > 1 ? "days" : "day";
    var modifyStatus = status === "active" ? "inactive" : "active";
    return /*#__PURE__*/React.createElement("tr", {
      key: "rule",
      className: "risk-rule-setting-card-table-data-details"
    }, /*#__PURE__*/React.createElement("td", {
      className: "risk-rule-setting-card-table-data-details-report-name"
    }, ruleName), /*#__PURE__*/React.createElement("td", {
      className: "risk-rule-setting-card-table-data-icon"
    }, /*#__PURE__*/React.createElement(ActionMenuWithButtons, {
      onDelete: function onDelete() {
        return _onDelete2(ruleId);
      },
      onStatusChange: function onStatusChange() {
        return _onStatusChange2(ruleId, modifyStatus);
      },
      onEdit: function onEdit() {
        return handleShow({
          ruleId: ruleId,
          ruleName: ruleName,
          ruleDays: ruleDays,
          organisationId: organisationId,
          rules: rules,
          excludeUser: excludeUser
        });
      },
      deleteProps: {
        title: "Delete rule",
        buttonText: "Delete",
        message: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
          className: "font-weight-bold mb-2"
        }, "Are you sure to delete this rule?"), /*#__PURE__*/React.createElement("p", {
          className: "text-secondary"
        }, "However you will be able to create a new rule like this again anytime."))
      },
      status: status,
      statusChanging: statusChanging
    })));
  })));
};
export var ActionMenuWithButtons = function ActionMenuWithButtons(props) {
  var onEdit = props.onEdit,
    onDelete = props.onDelete,
    onStatusChange = props.onStatusChange,
    _props$Icon = props.Icon,
    Icon = _props$Icon === void 0 ? HiOutlineDotsVertical : _props$Icon,
    deleteProps = props.deleteProps,
    status = props.status,
    statusChanging = props.statusChanging;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showConfirmation = _React$useState2[0],
    setShowConfirmation = _React$useState2[1];
  var handleClose = function handleClose() {
    return setShowConfirmation(false);
  };
  var handleOpen = function handleOpen() {
    return setShowConfirmation(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-card-table-data-icon-div",
    onClick: onEdit
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit")), /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-card-table-data-icon-div",
    onClick: onStatusChange
  }, status === "active" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FiToggleRight, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Make Inactive")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FiToggleLeft, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Make Active"))), /*#__PURE__*/React.createElement("div", {
    className: "risk-rule-card-table-data-icon-div",
    onClick: handleOpen
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Delete"))), /*#__PURE__*/React.createElement(DeleteConfirmation, _extends({
    show: showConfirmation,
    onClose: handleClose,
    onOk: onDelete
  }, deleteProps)));
};
var DeleteConfirmation = function DeleteConfirmation(props) {
  var show = props.show,
    onClose = props.onClose,
    title = props.title,
    onOk = props.onOk,
    message = props.message,
    buttonText = props.buttonText;
  var onAgree = function onAgree() {
    onOk();
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, title || "Alert")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, message), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: onAgree
  }, buttonText)));
};

/*  rule list */
export var RuleList = ["Work hours", "Idle time", "Unproductive Apps Time"];
export var RuleCondition = ["less than", "greater than"];
/*  hour list */
export var HourList = [{
  sec: 3600,
  hours: "1 hours"
}, {
  sec: 5400,
  hours: "1 hour 30 mins"
}, {
  sec: 7200,
  hours: "2 hours"
}, {
  sec: 9000,
  hours: "2 hours 30 mins"
}, {
  sec: 10800,
  hours: "3 hours"
}, {
  sec: 12600,
  hours: "3 hours 30 mins"
}, {
  sec: 14400,
  hours: "4 hours"
}, {
  sec: 16200,
  hours: "4 hours 30 mins"
}, {
  sec: 18000,
  hours: "5 hours"
}, {
  sec: 19800,
  hours: "5 hours 30 mins"
}, {
  sec: 21600,
  hours: "6 hours"
}, {
  sec: 23400,
  hours: "6 hours 30 mins"
}, {
  sec: 25200,
  hours: "7 hours"
}, {
  sec: 27000,
  hours: "7 hours 30 mins"
}, {
  sec: 28800,
  hours: "8 hours"
}, {
  sec: 30600,
  hours: "8 hours 30 mins"
}, {
  sec: 32400,
  hours: "9 hours"
}, {
  sec: 34200,
  hours: "9 hours 30 mins"
}, {
  sec: 36000,
  hours: "10 hours"
}, {
  sec: 37800,
  hours: "10 hours 30 mins"
}];
/*  day list */
export var DayList = [{
  label: "1 day",
  value: 1
}, {
  label: "2 days",
  value: 2
}, {
  label: "3 days",
  value: 3
}, {
  label: "4 days",
  value: 4
}, {
  label: "5 days",
  value: 5
}];
var RiskRuleModal = function RiskRuleModal(props) {
  var _ruleUserData$ruleOrg;
  var handleClose = props.handleClose,
    riskModal = props.riskModal,
    organisationId = props.organisationId,
    ruleUserData = props.ruleUserData,
    timeZone = props.timeZone;
  if (riskModal === null) {
    return null;
  }
  var userData = ruleUserData === null || ruleUserData === void 0 ? void 0 : (_ruleUserData$ruleOrg = ruleUserData.ruleOrganisationUserDetails) === null || _ruleUserData$ruleOrg === void 0 ? void 0 : _ruleUserData$ruleOrg.userData;
  var defaultRuleValues = {
    rules: [{
      ruleType: "Work hours",
      ruleTimeSec: "3600",
      ruleTimeCondition: "less than"
    }],
    ruleName: "",
    ruleDays: 1,
    excludeUser: []
  };
  var isNewRule = React.useMemo(function () {
    return riskModal != null && Object.keys(riskModal).length < 1;
  });
  var excludeUserOnChange = function excludeUserOnChange(setFieldValue) {
    return function (selectedArray) {
      if (selectedArray) {
        setFieldValue("excludeUser", selectedArray.map(function (item) {
          return item.value;
        }));
      } else {
        setFieldValue("excludeUser", []);
      }
    };
  };
  var _useMutation5 = useMutation(ADD_RISK_DETECTOR_RULE_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addRiskDetectorRule = _useMutation6[0],
    adding = _useMutation6[1].loading;
  var _useMutation7 = useMutation(EDIT_RISK_DETECTOR_RULE_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    editRiskDetectorRule = _useMutation8[0],
    editadding = _useMutation8[1].loading;
  var addRiskRule = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values, _ref3) {
      var setFieldError, rules, ruleDays, excludeUser, ruleName, newRules, response, _response, errorMessage;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setFieldError = _ref3.setFieldError;
            if (!adding) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            // console.log("values");
            // console.log(values);
            rules = values.rules, ruleDays = values.ruleDays, excludeUser = values.excludeUser;
            ruleName = values.ruleName;
            ruleName = ruleName || "Untittle";
            newRules = rules.reduce(function (acc, curr) {
              var ruleTimeSec = curr.ruleTimeSec,
                ruleTimeCondition = curr.ruleTimeCondition,
                ruleType = curr.ruleType;
              acc.push({
                ruleType: ruleType,
                ruleTimeSec: ruleTimeSec,
                ruleTimeCondition: ruleTimeCondition
              });
              return acc;
            }, []); //const addedRules = rules;
            // console.log("newRules");
            // console.log(newRules);
            _context3.prev = 7;
            if (riskModal !== null && riskModal !== void 0 && riskModal.ruleId) {
              _context3.next = 20;
              break;
            }
            _context3.next = 11;
            return addRiskDetectorRule({
              variables: {
                ruleId: (riskModal === null || riskModal === void 0 ? void 0 : riskModal.ruleId) || null,
                ruleName: ruleName,
                rules: newRules,
                ruleDays: Number(ruleDays),
                excludeUser: excludeUser,
                organisationId: organisationId,
                timeZone: timeZone
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LIST_RISK_DETECTOR_RULE_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 11:
            response = _context3.sent;
            if (!(!response || !response.data || response.data.addRiskDetectorRule == null)) {
              _context3.next = 16;
              break;
            }
            throw new Error("error");
          case 16:
            handleClose();
            toast.success(isNewRule ? "Rule added successfully!" : "Rule updated successfully!");
          case 18:
            _context3.next = 29;
            break;
          case 20:
            _context3.next = 22;
            return editRiskDetectorRule({
              variables: {
                ruleId: (riskModal === null || riskModal === void 0 ? void 0 : riskModal.ruleId) || null,
                ruleName: ruleName,
                rules: newRules,
                ruleDays: Number(ruleDays),
                excludeUser: excludeUser,
                organisationId: organisationId,
                timeZone: timeZone
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LIST_RISK_DETECTOR_RULE_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 22:
            _response = _context3.sent;
            if (!(!_response || !_response.data || _response.data.editRiskDetectorRule == null)) {
              _context3.next = 27;
              break;
            }
            throw new Error("error");
          case 27:
            handleClose();
            toast.success(isNewRule ? "Rule added successfully!" : "Rule updated successfully!");
          case 29:
            _context3.next = 35;
            break;
          case 31:
            _context3.prev = 31;
            _context3.t0 = _context3["catch"](7);
            errorMessage = (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || "";
            if (errorMessage.includes("Rule type already exists")) {
              setFieldError("ruleType", "Rule type already exists");
            } else if (errorMessage.includes("Rules contain repeated condition")) {
              setFieldError("formError", "Rule type already exists");
            } else if (errorMessage.includes("You've reached the maximum")) {
              setFieldError("formError", errorMessage.replace("GraphQL error: ", ""));
            } else {
              setFieldError("formError", "Something went wrong! Please try again later");
            }
          case 35:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[7, 31]]);
    }));
    return function addRiskRule(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  var isMobileView = window.innerWidth < 768;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobileView ? /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true,
    size: "xl",
    contentClassName: "risk-rule-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "risk-rule-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "risk-rule-modal-title"
  }, isNewRule ? "Create Risk Triggers" : "Edit Risk Triggers")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "risk-rule-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: isNewRule ? defaultRuleValues : riskModal,
    validationSchema: RiskSchema,
    onSubmit: addRiskRule
  }, function (_ref5) {
    var isSubmitting = _ref5.isSubmitting,
      errors = _ref5.errors,
      touched = _ref5.touched,
      values = _ref5.values;
    var excludeUserOptions = userData;
    var ruleDayTitle = values.ruleDays > 1 ? "days" : "day";
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "ruleName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Name of the Trigger "), /*#__PURE__*/React.createElement("span", {
        className: "risk-ex-text"
      }, " (Ex: Less working hours)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "rule-setting-err"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Field, {
        as: Form.Control,
        name: "ruleName",
        type: "text",
        placeholder: "Enter name of the trigger",
        isInvalid: errors.ruleName && touched.ruleName
      }));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("p", {
      className: "rule-sub-div-heading"
    }, "Risk Trigger Rule")), /*#__PURE__*/React.createElement(FieldArray, {
      name: "rules",
      render: function render(ruleArrayHelpers) {
        return /*#__PURE__*/React.createElement(Col, {
          xs: 12,
          className: "risk-setting-field-array"
        }, /*#__PURE__*/React.createElement("div", null, values.rules.map(function (team, teamIndex) {
          // const emailError = errorMessage(errors, touched, `users[${userIndex}].email`);
          // const displayNameError = errorMessage(errors, touched, `users[${userIndex}].displayName`);

          return /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            className: "mb-2 risk-rule-condition-section-mobile-border"
          }, /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section"
          }, /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-mobile-view-div"
          }, "On average,", /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-hourList-whole-div"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "rules[".concat(teamIndex, "].ruleType")
          }, function (fieldProps) {
            var field = fieldProps.field,
              meta = fieldProps.meta;
            return /*#__PURE__*/React.createElement(Form.Group, {
              className: "risk-rule-condition-section-hourList"
            }, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              placeholder: "Select rule"
            }, field), RuleList.map(function (key, index) {
              return /*#__PURE__*/React.createElement("option", {
                key: key,
                value: key
              }, key);
            })));
          })), "are", /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-hourList-whole-div"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "rules[".concat(teamIndex, "].ruleTimeCondition")
          }, function (fieldProps) {
            var field = fieldProps.field,
              meta = fieldProps.meta;
            return /*#__PURE__*/React.createElement(Form.Group, {
              className: "risk-rule-condition-section-hourList"
            }, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              placeholder: "Select condition"
            }, field), RuleCondition.map(function (key, index) {
              return /*#__PURE__*/React.createElement("option", {
                key: key,
                value: key
              }, key);
            })));
          }))), /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-mobile-view-div"
          }, /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-hourList-whole-div"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "rules[".concat(teamIndex, "].ruleTimeSec")
          }, function (fieldProps) {
            var field = fieldProps.field,
              meta = fieldProps.meta;
            return /*#__PURE__*/React.createElement(Form.Group, {
              className: "risk-rule-condition-section-hourList"
            }, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              placeholder: "Select hours"
            }, field), HourList.map(function (key, index) {
              return /*#__PURE__*/React.createElement("option", {
                key: key.sec,
                value: key.sec
              }, key.hours);
            })));
          })), /*#__PURE__*/React.createElement(Col, null, values.rules.length !== 1 ?
          /*#__PURE__*/
          // <Button
          //   variant="link"
          //   className="risk-setting-remove-button"
          //   size="sm"
          //   onClick={() => ruleArrayHelpers.remove(teamIndex)}
          // >
          //   Remove
          // </Button>
          React.createElement(MdDeleteForever, {
            className: "risk-setting-remove-button",
            onClick: function onClick() {
              return ruleArrayHelpers.remove(teamIndex);
            }
          }) : null))), values.rules.length === teamIndex + 1 ? " " : /*#__PURE__*/React.createElement("div", {
            className: "risk-setting-and-text"
          }, "and"));
        })), /*#__PURE__*/React.createElement("div", {
          className: "risk-setting-add-div"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "link",
          className: "risk-setting-add-button",
          onClick: function onClick() {
            return ruleArrayHelpers.push({
              ruleType: "Work hours",
              ruleTimeSec: "3600",
              ruleTimeCondition: "less than"
            });
          }
        }, "+ Add rule")));
      }
    }), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-4 risk-rule-condition-section-days"
    }, "In the last", /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-condition-section-hourList-whole-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "ruleDays"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, {
        className: "risk-rule-condition-section-hourList"
      }, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select days"
      }, field), DayList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.label);
      })));
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "excludeUser"
    }, function (_ref6) {
      var field = _ref6.field,
        form = _ref6.form;
      //console.log("field.value", field.value);
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Exclude User from the Trigger (optional)"), /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: excludeUserOptions.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: excludeUserOnChange(form.setFieldValue),
        options: excludeUserOptions,
        isMulti: true
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-condition-section-list-text"
    }, /*#__PURE__*/React.createElement("span", null, values.rules.map(function (data, teamIndex) {
      var ruleHourTitle = Number(data.ruleTimeSec) / 60 / 60 > 1 ? "hours" : "hour";
      return /*#__PURE__*/React.createElement("div", {
        className: "risk-rule-condition-section-list-2"
      }, "On average, ", data.ruleType.toLowerCase(), " is ", data.ruleTimeCondition, " ", Number(data.ruleTimeSec) / 60 / 60, " ", ruleHourTitle, " ", values.rules.length === teamIndex + 1 ? " " : "and ");
    }), "In the last ", values.ruleDays, " ", ruleDayTitle, ".")), /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center justify-content-center mx-n1 risk-rule-modal-create-button"
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-1 text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "risk-rule-modal-button",
      variant: "primary",
      size: "sm",
      type: "submit",
      disabled: isSubmitting || adding
    }, isSubmitting || isNewRule ? "Create Risk Trigger" : adding ? "Creating..." : "Update Risk Trigger"), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error risk-modal-data-error"
    }, errors.formError) : null)))));
  }))) : /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    className: "risk-rule-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "risk-rule-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "risk-rule-modal-title"
  }, isNewRule ? "Create Risk Triggers" : "Edit Risk Triggers")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "risk-rule-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: isNewRule ? defaultRuleValues : riskModal,
    validationSchema: RiskSchema,
    onSubmit: addRiskRule
  }, function (_ref7) {
    var isSubmitting = _ref7.isSubmitting,
      errors = _ref7.errors,
      touched = _ref7.touched,
      values = _ref7.values;
    var excludeUserOptions = userData;
    var ruleDayTitle = values.ruleDays > 1 ? "days" : "day";
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "ruleName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Name of the Trigger "), /*#__PURE__*/React.createElement("span", {
        className: "risk-ex-text"
      }, " (Ex: Less working hours)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "rule-setting-err"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Field, {
        as: Form.Control,
        name: "ruleName",
        type: "text",
        placeholder: "Enter name of the trigger",
        isInvalid: errors.ruleName && touched.ruleName
      }));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("p", {
      className: "rule-sub-div-heading"
    }, "Risk Trigger Rule")), /*#__PURE__*/React.createElement(FieldArray, {
      name: "rules",
      render: function render(ruleArrayHelpers) {
        return /*#__PURE__*/React.createElement(Col, {
          xs: 12,
          className: "risk-setting-field-array"
        }, /*#__PURE__*/React.createElement("div", null, values.rules.map(function (team, teamIndex) {
          // const emailError = errorMessage(errors, touched, `users[${userIndex}].email`);
          // const displayNameError = errorMessage(errors, touched, `users[${userIndex}].displayName`);

          return /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            className: "mb-2 risk-rule-condition-section-mobile-border"
          }, /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section"
          }, "On average,", /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-hourList-whole-div"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "rules[".concat(teamIndex, "].ruleType")
          }, function (fieldProps) {
            var field = fieldProps.field,
              meta = fieldProps.meta;
            return /*#__PURE__*/React.createElement(Form.Group, {
              className: "risk-rule-condition-section-hourList"
            }, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              placeholder: "Select rule"
            }, field), RuleList.map(function (key, index) {
              return /*#__PURE__*/React.createElement("option", {
                key: key,
                value: key
              }, key);
            })));
          })), "are", /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-hourList-whole-div"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "rules[".concat(teamIndex, "].ruleTimeCondition")
          }, function (fieldProps) {
            var field = fieldProps.field,
              meta = fieldProps.meta;
            return /*#__PURE__*/React.createElement(Form.Group, {
              className: "risk-rule-condition-section-hourList"
            }, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              placeholder: "Select condition"
            }, field), RuleCondition.map(function (key, index) {
              return /*#__PURE__*/React.createElement("option", {
                key: key,
                value: key
              }, key);
            })));
          })), /*#__PURE__*/React.createElement("div", {
            className: "risk-rule-condition-section-hourList-whole-div"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "rules[".concat(teamIndex, "].ruleTimeSec")
          }, function (fieldProps) {
            var field = fieldProps.field,
              meta = fieldProps.meta;
            return /*#__PURE__*/React.createElement(Form.Group, {
              className: "risk-rule-condition-section-hourList"
            }, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              placeholder: "Select hours"
            }, field), HourList.map(function (key, index) {
              return /*#__PURE__*/React.createElement("option", {
                key: key.sec,
                value: key.sec
              }, key.hours);
            })));
          })), /*#__PURE__*/React.createElement(Col, null, values.rules.length !== 1 ?
          /*#__PURE__*/
          // <Button
          //   variant="link"
          //   className="risk-setting-remove-button"
          //   size="sm"
          //   onClick={() => ruleArrayHelpers.remove(teamIndex)}
          // >
          //   Remove
          // </Button>
          React.createElement(MdDeleteForever, {
            className: "risk-setting-remove-button",
            onClick: function onClick() {
              return ruleArrayHelpers.remove(teamIndex);
            }
          }) : null)), values.rules.length === teamIndex + 1 ? " " : /*#__PURE__*/React.createElement("div", {
            className: "risk-setting-and-text"
          }, "and"));
        })), /*#__PURE__*/React.createElement("div", {
          className: "risk-setting-add-div"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "link",
          className: "risk-setting-add-button",
          onClick: function onClick() {
            return ruleArrayHelpers.push({
              ruleType: "Work hours",
              ruleTimeSec: "3600",
              ruleTimeCondition: "less than"
            });
          }
        }, "+ Add rule")));
      }
    }), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-4 risk-rule-condition-section-days"
    }, "In the last", /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-condition-section-hourList-whole-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "ruleDays"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, {
        className: "risk-rule-condition-section-hourList"
      }, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select days"
      }, field), DayList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.label);
      })));
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "excludeUser"
    }, function (_ref8) {
      var field = _ref8.field,
        form = _ref8.form;
      //console.log("field.value", field.value);
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Exclude User from the Trigger (optional)"), /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: excludeUserOptions.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: excludeUserOnChange(form.setFieldValue),
        options: excludeUserOptions,
        isMulti: true
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-condition-section-list-text"
    }, /*#__PURE__*/React.createElement("span", null, values.rules.map(function (data, teamIndex) {
      var ruleHourTitle = Number(data.ruleTimeSec) / 60 / 60 > 1 ? "hours" : "hour";
      return /*#__PURE__*/React.createElement("div", {
        className: "risk-rule-condition-section-list-2"
      }, "On average, ", data.ruleType.toLowerCase(), " is ", data.ruleTimeCondition, " ", Number(data.ruleTimeSec) / 60 / 60, " ", ruleHourTitle, " ", values.rules.length === teamIndex + 1 ? " " : "and ");
    }), "In the last ", values.ruleDays, " ", ruleDayTitle, ".")), /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center justify-content-center mx-n1 risk-rule-modal-create-button"
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-1 text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "risk-rule-modal-button",
      variant: "primary",
      size: "sm",
      type: "submit",
      disabled: isSubmitting || adding
    }, isSubmitting || isNewRule ? "Create Risk Trigger" : adding ? "Creating..." : "Update Risk Trigger"), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error risk-modal-data-error"
    }, errors.formError) : null)))));
  }))));
};
export default RiskRuleSetting;